
import * as formats from './format';

export default {
  ...formats  
}



/** WEBPACK FOOTER **
 ** ./src/utils/index.js
 **/